import { Box, Modal } from "@mui/material";
import React from "react";
import { IoClose } from "react-icons/io5";


interface ModalProps {
  open: boolean;
  label?: string;
  onClose?: () => void;
  onSubmit?: () => void;
  company?: any;
  setCompany?: any;
  children?: any;
  maxWidth?: number | string;
  contentClassName?: string;
}
const CustomModal = ({
  open,
  onClose,
  label,
  children,
  maxWidth = 800,
  contentClassName = "",
}: ModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={""}
      sx={{
        "& .MuiModal-backdrop": {
          backdropFilter: " blur(4px) !important",
          background: "#00000099 !important",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth,
          width: { xs: "96vw", sm: "94vw", md: "92vw" },
          maxHeight: { xs: "94vh", sm: "90vh" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 },
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderRadius: "10px",
          overflow: "hidden",
        }}
        className={`bg-primary ${contentClassName}`.trim()}
      >
        <div className={"w-full flex justify-between items-start gap-3 flex-shrink-0"}>
          <div className={"text-lg sm:text-xl md:text-2xl font-bold text-primaryText leading-snug pr-2"}>
            {label}
          </div>
          <IoClose onClick={onClose} size={20} className={"text-white cursor-pointer shrink-0"} />
        </div>
        <div className={"flex-1 overflow-y-auto overflow-x-hidden pr-1"}>
          {children}
        </div>
      </Box>
    </Modal>
  );
};
export default CustomModal;
